import React from "react";
import { useContext } from "react";
import { useEffect } from "react";
import Main from "../../components/main";
import { CheckListContext } from "../../utils/checkListContext";
import { useQuery } from "../../utils/useQuery";
import { MdStar } from "react-icons/md";
import { useFetchChecklist } from "../../utils/useFetchChecklist";
import { API_BASE_URL, API_ROUTES } from "../../config";
import ProgressSteps from "./ProgressSteps";
import Loader from "../../components/Loader/Loader";

export default function AdminNewCheckListTable() {
  const queryParams = useQuery();
  const product_Name = queryParams.get("product_name");
  const model_no = queryParams.get("model_no");
  const year = queryParams.get("year");
  const { setLoadCheck, rating, setChecklistData } =
    useContext(CheckListContext);

  const [data, fetchdata, fetching, statusBE] = useFetchChecklist(
    `${API_BASE_URL.BASE_URL}${API_ROUTES.FETCH_CHECKLIST_QUESTIONS_ROUTE}`
  );

  useEffect(() => {
    if (statusBE) {
      setChecklistData(data?.data);
      setLoadCheck(true);
    }
  }, [data]);

  return (
    <>
      {fetching ? (
        <Loader />
      ) : (
        <>
          <Main>
            <span style={{ fontSize: "20px", fontWeight: "800" }}>
              {product_Name} {model_no} {year}
            </span>
            {(!rating?.hasOwnProperty("mech_rating") && rating?.baseline_score > 0) && (
              <span style={{ display: "flex", flexDirection: "row" }}>
                <b>Rating:</b>{" "}
                <span
                  style={{
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "12px",
                  }}
                >
                  {" "}
                  {Array.apply(null, { length: 5 }).map((e, i) => {
                    // console.log("hello",i,proItem.rating)
                    if (i + 1 <= rating?.baseline_score) {
                      return (
                        <MdStar
                          style={{
                            color: "#FFBD00",
                            width: "20px",
                            height: "20px",
                          }}
                          key={i}
                        />
                      );
                    } else {
                      return (
                        <MdStar
                          style={{
                            color: "#D1D1D1",
                            width: "20px",
                            height: "20px",
                          }}
                          key={i}
                        />
                      );
                    }
                  })}
                  {rating?.baseline_score > 0 ? `(${rating?.baseline_score})` : ""}
                </span>
              </span>
            )}
            {rating?.mech_rating > 0 && (
              <span style={{ display: "flex", flexDirection: "row" }}>
                <b>Mech Rating:</b>{" "}
                <span
                  style={{
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {" "}
                  {Array.apply(null, { length: 5 }).map((e, i) => {
                    // console.log("hello",i,proItem.rating)
                    if (i + 1 <= rating?.mech_rating) {
                      return (
                        <MdStar
                          style={{
                            color: "#FFBD00",
                            width: "20px",
                            height: "20px",
                          }}
                          key={i}
                        />
                      );
                    } else {
                      return (
                        <MdStar
                          style={{
                            color: "#D1D1D1",
                            width: "20px",
                            height: "20px",
                          }}
                          key={i}
                        />
                      );
                    }
                  })}
                  {rating?.mech_rating > 0 ? `(${rating?.mech_rating})` : ""}
                </span>
              </span>
            )}
            {rating?.tech_rating > 0 && (
              <span style={{ display: "flex", flexDirection: "row" }}>
                <b>Tech Rating:</b>{" "}
                <span
                  style={{
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "12px",
                  }}
                >
                  {" "}
                  {Array.apply(null, { length: 5 }).map((e, i) => {
                    // console.log("hello",i,proItem.rating)
                    if (i + 1 <= rating?.tech_rating) {
                      return (
                        <MdStar
                          style={{
                            color: "#FFBD00",
                            width: "20px",
                            height: "20px",
                          }}
                          key={i}
                        />
                      );
                    } else {
                      return (
                        <MdStar
                          style={{
                            color: "#D1D1D1",
                            width: "20px",
                            height: "20px",
                          }}
                          key={i}
                        />
                      );
                    }
                  })}
                  {rating?.tech_rating > 0 ? `(${rating?.tech_rating})` : ""}
                </span>
              </span>
            )}
          </Main>
          <ProgressSteps />
        </>
      )}
    </>
  );
}